<template>
  <div class="filter-checkbox-list">
    <FormCheckbox
      v-for="opt in options"
      :key="opt.value"
      size="small"
      :value="isSelected(opt.value)"
      :label="hasOptionSlot ? null : opt.text"
      :terms="hasOptionSlot"
      @input="toggle(opt.value)"
    >
      <template v-if="hasOptionSlot" #label>
        <slot name="option" :option="opt" />
      </template>
    </FormCheckbox>
  </div>
</template>

<script>
import FormCheckbox from '@/components/form/FormCheckbox';

/**
 * Presentational multi-select checkbox list for a filter popover.
 * Props in / events out: it owns the toggle math and emits the resulting array via `change`.
 * Render custom option rows (icons, tags, …) through the scoped `option` slot.
 */
export default {
  name: 'FilterCheckboxList',
  components: { FormCheckbox },
  props: {
    // Each option: { value, text }.
    options: { type: Array, required: true },
    // Currently-selected values.
    value: { type: Array, default: () => [] },
  },
  computed: {
    hasOptionSlot() {
      return !!this.$scopedSlots.option;
    },
  },
  methods: {
    isSelected(v) {
      return this.value.includes(v);
    },
    toggle(v) {
      const next = this.value.includes(v) ? this.value.filter((x) => x !== v) : [...this.value, v];
      this.$emit('change', next);
    },
  },
};
</script>

<style lang="scss">
// Full-row grey hover on each option, matching FilterRadioList so single- and multi-select
// popovers feel identical. FormCheckbox on its own only darkens the check border on hover, so
// without this the multi-select rows had no row highlight. Scoped to the filter list, so no other
// FormCheckbox in the app is affected.
.filter-checkbox-list {
  .form-checkbox {
    width: 100%;
    border-radius: $border-radius-small;
    transition: background ease 100ms;

    &:hover {
      background: $color-hover;
    }
  }
}
</style>
